import { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router";

import { isRouteAvailable, legacyHandOverUrl } from "./betaLock";
import { DASHBOARD, ONBOARDING } from "./routes";

const BetaLockRoute = () => {
  const { pathname, search } = useLocation();
  const allowed = isRouteAvailable(pathname);
  const legacyUrl = allowed ? null : legacyHandOverUrl(`${pathname}${search}`);

  useEffect(() => {
    if (legacyUrl) window.location.replace(legacyUrl);
  }, [legacyUrl]);

  if (pathname === DASHBOARD) {
    const requested = new URLSearchParams(search).get("onboarding");
    if (requested) {
      return (
        <Navigate
          to={requested === "edit" ? `${ONBOARDING}?edit=1` : ONBOARDING}
          replace
        />
      );
    }
  }

  if (allowed) return <Outlet />;
  if (legacyUrl) return null;

  return <Navigate to={DASHBOARD} replace />;
};

export default BetaLockRoute;
